import routes from './routes'

export default {
    path: '/_storybook',
    display: 'Storybook',
    component: () => import(/* webpackChunkName: "storybook" */ './storybook.vue'),
    children: routes,
    meta: {
        roles: ['Admin'],
        layout: 'empty',
    },
}
